import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "./ui/dialog";
import { KeyRound, Copy, Check } from "lucide-react";
import { toast } from "sonner";

export default function PasswordDisplayDialog({ open, onOpenChange, payload }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    if (!payload?.password) return;
    try {
      await navigator.clipboard.writeText(payload.password);
      setCopied(true);
      toast.success("Password copiata negli appunti");
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      toast.error("Copia non riuscita, seleziona manualmente");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="password-display-dialog" className="max-w-md rounded-sm">
        <DialogHeader>
          <div className="inline-flex h-10 w-10 items-center justify-center rounded-sm bg-brand-gold/15 text-brand-gold mb-2">
            <KeyRound size={20} />
          </div>
          <DialogTitle className="wordmark text-brand-blue">
            {payload?.title || "Password generata"}
          </DialogTitle>
          <DialogDescription>
            {payload?.subtitle ||
              "Copia ora questa password. Non sarà più visibile."}
          </DialogDescription>
        </DialogHeader>

        <div className="bg-brand-bg border border-brand-line rounded-sm p-4">
          <div className="text-xs uppercase tracking-widest text-brand-muted mb-1">
            {payload?.email || "Utente"}
          </div>
          <div
            data-testid="generated-password-value"
            className="font-mono text-lg text-brand-ink break-all select-all"
          >
            {payload?.password || ""}
          </div>
        </div>

        <DialogFooter>
          <button
            data-testid="copy-password-btn"
            onClick={copy}
            className="btn-primary inline-flex items-center gap-2"
          >
            {copied ? <Check size={16} /> : <Copy size={16} />}
            {copied ? "Copiata" : "Copia password"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
